// utils/apiService.ts
import axios from 'axios';

export const callService = async (
    service_name: string,
    data: { param: string; value: any }[] = []
) => {
    const lead_profile_id = localStorage.getItem('lead_profile_id');

    if (!lead_profile_id) {
        console.error('lead_profile_id not found in localStorage');
        return;
    }

    const payload = {
        lead_profile_id,
        service_name,
        data,
    };

    try {
        const response = await axios.post('/api/lead-service', payload, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.log(`✅ Service "${service_name}" called successfully`, response.data); // ✅ success message

        return response.data;
    } catch (error) {
        console.error(`❌ Error calling "${service_name}":`, error);
        throw error;
    }
};




// // useable APi Calling for get Leads

// export const callService = async (
//     service_name: string,
//     data: { param: string, value: any }[] = []
// ) => {

//     const lead_profile_id = localStorage.getItem("lead_profile_id");

//     if (!lead_profile_id) {
//         console.log("Lead Profile Id not Found in LocalStorage")
//         return;
//     }
//     const payload = {
//         lead_profile_id,
//         service_name,
//         data
//     };

//     try {
//         const response = await fetch("https://nestfin.app:8443/api/lead-service")
//     }

// }